import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { applyTheme, getStoredTheme, setStoredTheme } from "../lib/theme";

const ThemeContext = createContext({
  theme: "system",
  resolved: "dark",
  setTheme: () => {},
});

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getStoredTheme);
  const [resolved, setResolved] = useState(() =>
    typeof document !== "undefined" ? document.documentElement.getAttribute("data-theme") || "dark" : "dark"
  );

  const setTheme = useCallback((next) => {
    setThemeState(next);
    setStoredTheme(next);
  }, []);

  useEffect(() => {
    applyTheme(theme);
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const sync = () => {
      applyTheme(theme);
      setResolved(document.documentElement.getAttribute("data-theme") || "light");
    };
    sync();
    if (theme === "system") {
      mq.addEventListener("change", sync);
      return () => mq.removeEventListener("change", sync);
    }
    return undefined;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, resolved, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
